import React from "react";
import styled from "styled-components";

import { Desktop } from "../containers/common";

// import db from "../../../public/assets/images/dev/dario.jpg";
// import cj from "../../../public/assets/images/dev/cj.jpg";
// import anim from "../../../public/assets/images/dev/anim.jpg";
// import lb from "../../../public/assets/images/dev/lb.jpg";
// import agbo from "../../../public/assets/images/dev/agbo.jpg";
// import dn from "../../../public/assets/images/dev/dn.jpg";
// import tyron from "../../../public/assets/images/dev/tyron.jpg";
// import dv from "../../../public/assets/images/dev/dv.jpg";
// import ea from "../../../public/assets/images/dev/ea.jpg";
// import ga from "../../../public/assets/images/dev/ga.jpg";
// import msk from "../../../public/assets/images/dev/msk.jpg";
// import pc from "../../../public/assets/images/dev/pc.jpg";
// import sa from "../../../public/assets/images/dev/sa.jpg";
// import wm from "../../../public/assets/images/dev/wm.jpg";
// import cf from "../../../public/assets/images/dev/cf.jpg";
// import pg from "../../../public/assets/images/dev/pg.jpg";
// import fz from "../../../public/assets/images/dev/fz.jpg";
// import dd from "../../../public/assets/images/dev/dd.jpg";
// import vs from "../../../public/assets/images/dev/vs.jpg";
// import ca from "../../../public/assets/images/dev/ca.jpg";

import { HumanCard } from "../components/common";
import { StyledText } from "../components/common/basic";

const Humans = () => {
  return (
    <Desktop>
      <MainHolder>
        <StyledText height={32} fontFamily={500} margin={20}>
          The people that work to deliver the app!
        </StyledText>
        {/* <HumanCard
          duration={`2019 -\n present`}
          name="Dario Bianchi"
          position="Digital Lead"
          img={db}
          url="https://www.linkedin.com/in/dariobianchi/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2019 -\n present`}
          name="Sheriff Ayew"
          position="Practice Head"
          img={sa}
          url="https://www.linkedin.com/in/sheriffayew/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2019 -\n present`}
          name="Caryl Joshua Akonor"
          position="UI/UX Designer"
          img={cj}
          url="https://www.linkedin.com/in/carylakonor/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2019 -\n present`}
          name="Lord Barry Avemegah"
          position="Product Manager"
          img={lb}
          url="https://www.linkedin.com/in/lord-barry-avemegah-784643121/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <StyledText height={32} fontFamily={500} margin={20}>
          You Get What You Focus On
        </StyledText>
        <HumanCard
          duration={`2019 -\n 2020`}
          name="Anim Addo"
          position="Product Manager"
          img={anim}
          url="https://www.linkedin.com/in/anim-addo-b1129bb5/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2020`}
          name="Casprine Assempah"
          position="Mobile Engineer"
          img={ca}
          url="https://www.linkedin.com/in/casprine-assempah-2451437b/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2019 -\n present`}
          name="Kelvin Tyron"
          position="UI/UX Designer"
          img={tyron}
          url="https://www.linkedin.com/in/kelvintyron/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2019 -\n present`}
          name="Gloria Acheampong"
          position="Product Owner"
          img={ga}
          url="https://www.linkedin.com/in/gloria-acheampong-73284041/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        /> */}
        <StyledText height={32} fontFamily={500} margin={20}>
          You Can Find an Excuse or You Can Find a Way
        </StyledText>
        
        {/* <HumanCard
          duration={`2020 -\n present`}
          name="Dorcas Nartey"
          position="Product Owner"
          img={dn}
          url="https://www.linkedin.com/in/dorcas-n-3b986961/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2019 -\n 2020`}
          name="Kuku Akaba"
          position="Product Owner"
          img={msk}
          url="https://www.linkedin.com/in/kuku-akaba-17789126/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2020 -\n present`}
          name="Makafui Agbotta"
          position="Digital Spoke"
          img={agbo}
          url="https://www.linkedin.com/in/magbotta/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2019 -\n present`}
          name="Divine Dagadu"
          position="Mobile Engineer"
          img={dv}
          url="https://www.linkedin.com/in/divine-dagadu/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <StyledText height={32} fontFamily={500} margin={20}>
          Don’t Wish for It, Work for It
        </StyledText>
        <HumanCard
          duration={`2020 -\n 2021`}
          name="Emmanuel Arkorful"
          position="Backend Developer"
          img={ea}
          url="https://www.linkedin.com/in/emmanuel-a-1a58aaa5/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2019 -\n present`}
          name="Cynthia Emefa Fiamor"
          position="Scrum Master"
          img={cf}
          url="https://www.linkedin.com/in/cynthia-fiamor-6537a536/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2020 -\n present`}
          name="Wendy Nana Minta"
          position="Product Tester"
          img={wm}
          url="https://www.linkedin.com/in/wendy-nana-minta-58053477/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2019 -\n 2021`}
          name="Prince Omilana-Okine"
          position="QA Engineer"
          img={pc}
          url="https://www.linkedin.com/in/prince-charles-omilana-okine-1056a060/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <StyledText height={32} fontFamily={500} margin={20}>
          Know Your Limitations, and Defy Them
        </StyledText>
        <StyledText height={32} fontFamily={500} margin={20}>
          Excellence Does Not Require Perfection
        </StyledText>
        <HumanCard
          duration={`2020 -\n 2021`}
          name="Derek Duafa"
          position="Systems Engineer"
          img={dd}
          url="https://www.linkedin.com/in/derek-duafa/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2019 -\n 2021`}
          name="Gideon Aryeetey"
          position="Backend Engineer"
          img={fz}
          url="https://www.linkedin.com/in/gideon-aryeetey-22b45ab1/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2020 -\n 2021`}
          name="Bismark Avemegah"
          position="Mobile Developer"
          img={vs}
          url="https://www.linkedin.com/in/bismark-avemegah-b83020198/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        />
        <HumanCard
          duration={`2019 -\n present`}
          name="Poga Kuofie"
          position="Software Architect"
          img={pg}
          url="https://www.linkedin.com/in/poga-kuofie-b25a971b9/"
          onPress={(url) => {
            window.location.assign(url);
          }}
        /> */}
        <StyledText height={24} fontFamily={500} margin={20}>
          Wake Up. Kick Ass. Be Kind
        </StyledText>
      </MainHolder>
    </Desktop>
  );
};

const MainHolder = styled.div`
  display: grid;
  grid-template-columns: 140px 140px;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  gap: 20px;
  background-color: #f2f2f2;
  height: 650px;
  overflow: scroll;
  padding: 20px;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    height: 100vh;
  }
`;

export default Humans;
